<template>
  <s-task-list-layout
    :title="$t('eDocInternal.title')"
    history-u-r-l="/tasklist/eDocInternalHistory"
    :is-show-seach-area-prop="filterText !== ''"
    @searchIconClick="searchIconClick"
  >
    <template v-slot:toolbar-icon>
      <s-sort-icon v-model="orderingProp" />
    </template>
    <template
      v-slot:search-area
    >
      <s-server-filter-box
        ref="filterBox"
        :placeholder="$t('eDocSuggest.filterBox.hint')"
        :filter-text-prop="filterText"
        @search="search($event)"
      />
    </template>
    <v-skeleton-loader
      v-if="listLoading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <s-batch-agree-dialog
      v-if="showBatchModeBox"
      :only-show-suggest.sync="onlyShowPrefilled"
      :task-list="processData.records"
      @finish="onBatchFinish"
    />

    <s-int-list
      :process-data="processData"
      @itemClick="toDetailPage"
    />
    <!-- <s-int-detail
      v-else
      :item="detailPageObj"
      @finish="isListMode = true"
    /> -->
    <br><br><br><br><br><br>
  </s-task-list-layout>
</template>

<style scoped>
.entity-list-item + .entity-list-item {
  margin-left: 8px;
}
</style>

<script>

import { mapState } from 'vuex'
import store from '@/store'
import { docFlowModule } from '@/store/moduleName'
import STaskListLayout from './components/STaskListLayout'
import SIntList from './components/eDocInternal/SIntList'
// import SFilterBox from './components/eDocInternal/SFilterBox'
import SServerFilterBox from './components/GeneralList/SServerFilterBox'
import SSortIcon from './components/eDocInternal/SSortIcon.vue'
import SBatchAgreeDialog from './components/eDocInternal/SBatchAgreeDialog'

import { DOC_FLOW_STATUS, DOC_FLOW_TYPE, TASK_LIST_JOB_TYPE, INFLOW_STATUS_CODES } from '@/constant/constant'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import docFlowApi from '@/api/eDocInternal/docFlow'
import docFlow from '@/store/modules/eDocInternal/docFlow'
import signHelper from '@/helper/signHelper'
import { setStorage } from '@/utils/storageUtil'
import { taskMethod } from '@/mixins/taskMethod'

if (!store.state[docFlowModule]) store.registerModule(docFlowModule, docFlow)

export default {
  components: {
    STaskListLayout,
    SIntList,
    SServerFilterBox,
    SSortIcon,
    SBatchAgreeDialog
  },
  mixins: [docFlowMethod, taskMethod],
  data: function () {
    return {
      detailPageObj: null,
      dialog: false,
      businessCode: '',
      status: [DOC_FLOW_STATUS.WAITING],
      showBatchModeBox: true,
      jobType: TASK_LIST_JOB_TYPE.MY_JOB
      // onlyShowSuggestAndReceiver: false
    }
  },
  computed: {
    ...mapState({
      processData: state => state[docFlowModule].processData,
      taskListJobType: state => state[docFlowModule].taskListJobType,
      inflowStatus: state => state[docFlowModule].inflowStatus
    })
    /* onlyShowPrefilled: {
      get () {
        return this.$store.state[docFlowModule].onlyShowPrefilled
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setOnlyShowPrefilled', val)
        this.getProcessList(val, null, this.status)
      }
    },
    filterText: {
      get () {
        return this.$store.state[docFlowModule].filterText
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setFilterText', val)
        this.getProcessList(false, val, this.status)
      }
    } */
  },
  /*   watch: {
    onlyShowPrefilled: function (val) {
      this.$store.commit(docFlowModule + '/setOnlyShowPrefilled', val)
      this.getProcessList()
    }
  }, */
  created () {
    if (this.taskListJobType !== this.jobType || this.inflowStatus.length > 1) {
      this.$store.commit(docFlowModule + '/setPageNum', 1)
    }
    this.$store.commit(docFlowModule + '/setTaskListJobType', this.jobType)
    this.$store.commit(docFlowModule + '/setInflowStatus', [INFLOW_STATUS_CODES.ACTIVE])
    this.$store.commit(docFlowModule + '/setDocFlowType', DOC_FLOW_TYPE.DOC_FLOW)
    this.getProcessList(this.onlyShowPrefilled, this.filterText, this.status)
    this.showBatchModeBox = (this.filterText === '')
    // this.uploadFileUrl = docFlowApi.uploadFileUrl
  },
  methods: {
    toDetailPage: function (record) {
      if (!record.confirmReceivedEuid) {
        docFlowApi.markConfirmReceivedProcess(record.dfProcessId, function () {})
      }
      let path = `/tasklist/eDocInternalDetail/${record.dfProcessId}`
      setStorage(signHelper.REDIRECT_PATH, path)
      this.$router.push(path)
      // this.$store.commit(docFlowModule + '/setRedirectPath', path)
    },
    onBatchFinish () {
      this.getProcessList(false, null, this.status)
      this.refreshTaskListCount()
    },
    handlePageChange (value) {
      this.pageNum = value
      this.getProcessList(this.onlyShowPrefilled, this.filterText, this.status)
    }

  }
}
</script>
